import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="26" height="26" viewBox="0 0 26 26" {...props}>
      <title>{props.title || 'Genre'}</title>
      <g fill="none">
        <rect
          x="1.7"
          y="15.8466"
          width="8.36516"
          height="8.4534"
          rx="4.18258"
          stroke="currentColor"
          strokeWidth="2.6"
        />
        <rect
          x="15.9349"
          y="15.8466"
          width="8.36516"
          height="8.4534"
          rx="4.18258"
          stroke="currentColor"
          strokeWidth="2.6"
        />
        <rect
          x="1.7"
          y="1.7"
          width="8.36516"
          height="8.4534"
          rx="4.18258"
          stroke="currentColor"
          strokeWidth="2.6"
        />
        <rect
          x="15.9349"
          y="1.7"
          width="8.36516"
          height="8.4534"
          rx="4.18258"
          stroke="currentColor"
          strokeWidth="2.6"
        />
      </g>
    </Icon>
  )
}
